import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { DatepickerComponent } from '../datepicker-component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors, Form } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { QuizData } from 'src/app/questionaire/QuizData';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-weightlog',
  templateUrl: './weightlog.component.html',
  styleUrls: ['./weightlog.component.css']
})
export class WeightlogComponent implements OnInit {
  weightlogForm : FormGroup;
  @Output() doneSubmiting = new EventEmitter ();
  @ViewChild(DatepickerComponent) datepicker: DatepickerComponent;
  failedMessage: string;
  cookie: any;
  weightLogSaved: boolean;
  submitted = false;
  height;
  BMIw;
  BMIh;
  BMI;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  ngOnInit() {
    let regexPatterns = {
      weight: /^(\d+\.?\d*|\.\d+)$/,
   };
    this.weightlogForm  =  this.formBuilder.group({
      weight: ['', [Validators.required, Validators.pattern(regexPatterns.weight)]],
    });

    this._bkoffService.getHeight().then((res) => {
      console.log("res is " + res);
      this.height = res;
   });
  }
  get fmBuilder() { return this.weightlogForm.controls; }

  getFormControl(name:any) {
    return this.weightlogForm.get(name);
  }

  constructor(
    private router: Router,
    private _bkoffService: BackOffServiceService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private breakpointObserver: BreakpointObserver

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  backClick() {
    //needs implementation

  }

  closeWeightLog() {
    this.doneSubmiting.emit("saved");
    this.weightLogSaved = true;
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.weightlogForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.weightlogForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  roundTo(n, digits) {
      if (digits === undefined) {
        digits = 0;
      }
 
      var multiplicator = Math.pow(10, digits);
      n = parseFloat((n * multiplicator).toFixed(11));
      var test =(Math.round(n) / multiplicator);
      return +(test.toFixed(digits));
  }

  submitClick() {
    var hO;
    var hT;
    
    this.BMIw = (((this.weightlogForm.get(['weight']).value)*.4535));
    hO = this.height/12;
    console.log(hO + " is height");
    hT = hO * .3048;
    this.BMIh = hT*hT;

    this.BMI = (this.BMIw/this.BMIh);
    this.BMI = this.roundTo(this.BMI, 2);

    if (this.weightlogForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }
    
    var weightLogData = new LogsData();
    weightLogData.weight = this.weightlogForm.get(['weight']).value;
    weightLogData.BMI = this.BMI;
    weightLogData.weightDate = this.datepicker.dateEntry.toString();
    console.log(this.datepicker.dateEntry.toISOString())

    if (this.weightlogForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }

    this._bkoffService.createWeightLog(weightLogData).then((success)=>{
      this.doneSubmiting.emit("saved")
      this.weightLogSaved = true;
      this.weightlogForm.reset();

      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'Your Weight has been stored';
      modalRef.componentInstance.title = 'Success';
    }).catch(()=>{
     this.failedMessage  = "Error saving weight logs "
     this.weightLogSaved = false
     this.doneSubmiting.emit("failed")
     console.log(this.failedMessage)
    });

    // this._bkoffService.setCurrentWeight(Number(weightLogData.weight)).then((res) => {
    //   console.log("updated weight");
    //   var w : Number = 0;
    //   this._bkoffService.getCurrentWeight().then((res) => {
    //     w = res;
    //     console.log(w);
    //   })
    // })

  }
    
   sendUserFeedback(){
    
      const modalRef = this.modalService.open(NgbdModalContent);
      if (!this.weightLogSaved){
        modalRef.componentInstance.name = 'Error saving data , please try again';
      }
     
    }

}